
<script setup>

  import { ref } from 'vue';

  import TextArea from '../components/text-area.vue';

  import SelectionButton from '../components/selection-button.vue';

  import FileSelection from '../drawers/activity-5-file-selection.vue';

  import { posterStyles } from '../stores/activity-5.js';

  const fileSelectionDialog = ref( null );

  const style = posterStyles.find( ( { id } ) => id === 1 );

</script>

<template>

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-12">

    <div class="lg:col-span-3">

      <div class="text-sm font-bold">Header Image</div>

      <SelectionButton type="button" class="w-full h-64 mt-4" name="Header Image" :selection="style.headerImagePath"
      
        @click="fileSelectionDialog.select( 'Header Image', 'horizontal' ).then( path => style.headerImagePath = path )" />

    </div>

    <div class="lg:col-span-2">

      <label class="block text-sm font-bold" for="poster-title">Title</label>

      <TextArea id="poster-title" v-model="style.title" v-slot="{ count, maxLength }" :rows="1" :max-length="35">
        
        <div class="text-right mt-2 text-sm italic">{{ count }} of {{ maxLength }} characters used.</div>
      
      </TextArea>

      <label class="block mt-6 text-sm font-bold" for="poster-subtitle">Subtitle</label>

      <TextArea id="poster-subtitle" v-model="style.subtitle" v-slot="{ count, maxLength }" :rows="1" :max-length="40">
        
        <div class="text-right mt-2 text-sm italic">{{ count }} of {{ maxLength }} characters used.</div>
      
      </TextArea>

      <label class="block mt-6 text-sm font-bold" for="poster-paragraph-1">Paragraph 1</label>

      <TextArea id="poster-paragraph-1" v-model="style.paragraph1" v-slot="{ count, maxLength }" :rows="6" :max-length="350">
        
        <div class="text-right mt-2 text-sm italic">{{ count }} of {{ maxLength }} characters used.</div>
      
      </TextArea>

      <label class="block mt-6 text-sm font-bold" for="poster-paragraph-2">Paragraph 2</label>

      <TextArea id="poster-paragraph-2" v-model="style.paragraph2" v-slot="{ count, maxLength }" :rows="6" :max-length="350">
        
        <div class="text-right mt-2 text-sm italic">{{ count }} of {{ maxLength }} characters used.</div>
      
      </TextArea>

    </div>

    <div>

      <div class="text-sm font-bold">Side Image 1</div>

      <SelectionButton type="button" class="w-full max-w-xs aspect-square mt-4" name="Side Image 1" :selection="style.sideImage1Path"
      
        @click="fileSelectionDialog.select( 'Side Image 1', 'square' ).then( path => style.sideImage1Path = path )" />

      <label class="block mt-8 text-sm font-bold" for="poster-side-image-1-caption">Side Image 1 Caption</label>

      <TextArea id="poster-side-image-1-caption" v-model="style.sideImage1Caption" v-slot="{ count, maxLength }" :rows="1" :max-length="25">
        
        <div class="text-right mt-2 text-sm italic">{{ count }} of {{ maxLength }} characters used.</div>
      
      </TextArea>

      <div class="mt-6 text-sm font-bold">Side Image 2</div>

      <SelectionButton type="button" class="w-full max-w-xs aspect-square mt-4" name="Side Image 2" :selection="style.sideImage2Path"
      
        @click="fileSelectionDialog.select( 'Side Image 2', 'square' ).then( path => style.sideImage2Path = path )" />

      <label class="block mt-8 text-sm font-bold" for="poster-side-image-2-caption">Side Image 2 Caption</label>

      <TextArea id="poster-side-image-2-caption" v-model="style.sideImage2Caption" v-slot="{ count, maxLength }" :rows="1" :max-length="25">
        
        <div class="text-right mt-2 text-sm italic">{{ count }} of {{ maxLength }} characters used.</div>
      
      </TextArea>

    </div>

    <FileSelection ref="fileSelectionDialog" />

  </div>

</template>
